import { RootState, store } from 'app/store/configure-store';
import { DataLayers } from '@lyse-as/lte-salgskanaler-datalayers';

let dataLayers: DataLayers;

export const getDataLayers = (): DataLayers => {
  if (!dataLayers) {
    const selectedCustomerLocation = (store.getState() as RootState).userContext.selectedCustomerLocation;

    dataLayers = new DataLayers({
      currency: 'NOK',
      affiliation: 'altibox.no',
      page_context: 'selfcare',
      enable_data_layers: true,
      business_unit: 'b2c',
      ...(selectedCustomerLocation?.partnerNumber && {
        partner: {
          id: selectedCustomerLocation?.partnerNumber,
          name: selectedCustomerLocation?.partnerLegalName,
        },
      }),
    });
  }
  return dataLayers;
};

export interface GtmDataLayer {
  element_cta: string;
  element_category?: string;
}
